import { css } from '@emotion/core';
import { applyFont, media, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors,
  spacing = tokens.spacing,
  typography = tokens.typography;
export var primaryFeatures = {
  name: "1pi45u9",
  styles: "display:flex;flex-direction:column;gap:24px;padding:8px 0 0 0;"
};
export var secondaryFeatures = /*#__PURE__*/css(applyFont(typography.body), " display:flex;flex-direction:column;row-gap:8px;padding-top:32px;color:", colors.neutral.heavy.default, ";", media('>=tablet'), "{flex-direction:row;flex-wrap:wrap;}");
export var secondaryFeature = /*#__PURE__*/css("display:flex;flex-direction:row;gap:16px;padding:4px 0 4px 0;", media('>=tablet'), "{width:50%;}");
export var button = /*#__PURE__*/css("width:133px;margin-top:", spacing.m, ";", media('>=tablet'), "{display:none;}");
export var buttonText = /*#__PURE__*/css(applyFont(typography.captionBold));